export function viewThreeDrop(state, payload) {
  return {
    ...state,
    designChapter: updateDesignChapter(state.designChapter, payload),
  };
}

function updateDesignChapter(designChapter, payload) {
  let isStreakBroken = undefined;

  const updateInSlideTree = (slideTree) => {
    return slideTree.map((groupItem) => {
      if (payload.groupId === groupItem.groupId)
        return {
          ...groupItem,
          groupNodes: groupItem.groupNodes.map(updateGroupNode),
        };
      else
        return {
          ...groupItem,
          groupNodes: groupItem.groupNodes.map(resetNodeGroupToolTip),
        };
    });
  };

  const resetNodeGroupToolTip = (groupNode) => {
    return {
      ...groupNode,
      nodeComponents: groupNode.nodeComponents.map(resetNodeComponentsToolTip),
    };
  };

  const updateGroupNode = (groupNode) => {
    if (groupNode.nodeId === payload.nodeId)
      return {
        ...groupNode,
        nodeComponents: groupNode.nodeComponents.map(updateNodeComponent),
      };
    else
      return {
        ...groupNode,
        nodeComponents: groupNode.nodeComponents.map(
          resetNodeComponentsToolTip
        ),
      };
  };

  const resetNodeComponentsToolTip = (nodeComponent) => {
    return { ...nodeComponent, showTooltip: false };
  };

  const updateNodeComponent = (nodeComponent) => {
    if (nodeComponent.id === payload.positionId) {
      if (nodeComponent.answerId.includes(payload.optionId)) {
        isStreakBroken = false;
        return {
          ...nodeComponent,
          droppedId: payload.optionId,
          showTooltip: false,
        };
      } else {
        isStreakBroken = true;
        return {
          ...nodeComponent,
          droppedId: payload.optionId,
          showTooltip: false,
        };
      }
    }
    return { ...nodeComponent, showTooltip: false };
  };

  const updateCurrentStreak = (currentStreak) => {
    if (isStreakBroken) return 0;
    else return currentStreak + 1;
  };

  return {
    ...designChapter,
    currentView: {
      ...designChapter.currentView,
      slideTree: updateInSlideTree(designChapter.currentView.slideTree),
      options: {
        ...designChapter.currentView.options,
        list: setDroppedOptionVisibility(
          designChapter.currentView.options.list,
          payload.optionId
        ),
      },
      ...updateCompleteFeedbackData(designChapter.currentView, isStreakBroken),
    },
    currentStreak: updateCurrentStreak(designChapter.currentStreak),
    longestStreak: updateLongestStreak(designChapter, isStreakBroken),
  };
}

function setDroppedOptionVisibility(list, optionId) {
  return list.map((listItem) => {
    if (listItem.id === optionId) return { ...listItem, visible: false };
    return { ...listItem };
  });
}

function updateLongestStreak({ currentStreak, longestStreak }, isStreakBroken) {
  if (isStreakBroken || longestStreak > currentStreak) return longestStreak;
  else return currentStreak + 1;
}

function updateCompleteFeedbackData({ correctNodeComponents }, isStreakBroken) {
  if (correctNodeComponents != undefined) {
    if (isStreakBroken || isStreakBroken === undefined)
      return { correctNodeComponents };
    return { correctNodeComponents: correctNodeComponents + 1 };
  }
  return {};
}
